import { useEffect, useRef, useState } from "react";
import { scheibiMessages, pickNextIndex } from "@/data/funzone";

const DEFAULT_MSG = "Pssst … dein Status steht oben.";

export const ScheibiMascot = () => {
  const [msg, setMsg] = useState(DEFAULT_MSG);
  const [visible, setVisible] = useState(false);
  const idxRef = useRef(-1);
  const timer = useRef(null);

  const show = (text, ms = 4500) => {
    setMsg(text);
    setVisible(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setVisible(false), ms);
  };

  useEffect(() => {
    const t = setTimeout(() => show(DEFAULT_MSG, 5000), 800);
    return () => { clearTimeout(t); clearTimeout(timer.current); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const poke = () => {
    idxRef.current = pickNextIndex(scheibiMessages, idxRef.current);
    show(scheibiMessages[idxRef.current]);
  };

  return (
    <div className="absolute bottom-3 right-16 md:bottom-6 md:right-28 z-10 flex flex-col items-end" data-testid="scheibi-mascot">
      {visible && (
        <div className="fz-bubble-pop mb-2 max-w-[200px] rounded-2xl rounded-br-sm bg-white border border-slate-200 shadow-md px-3.5 py-2.5 text-sm font-medium text-slate-700" data-testid="scheibi-bubble" role="status">
          {msg}
        </div>
      )}
      <button
        onClick={poke}
        aria-label="Scheibi, unser Maskottchen — anklicken für einen Spruch"
        className="fz-float w-20 md:w-28 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 focus-visible:ring-offset-2 rounded-3xl transition-transform duration-200 active:scale-95"
        data-testid="scheibi-button"
      >
        <svg viewBox="0 0 140 110" className="w-full drop-shadow-md">
          <path d="M28 18 Q70 6 112 18 L122 74 Q70 86 18 74 Z" fill="url(#scheibiGlass)" stroke="#1e3a5f" strokeWidth="5" strokeLinejoin="round" />
          <path d="M38 26 L54 66" stroke="#e0f2fe" strokeWidth="7" strokeLinecap="round" opacity="0.9" />
          <path d="M50 24 L60 48" stroke="#e0f2fe" strokeWidth="4" strokeLinecap="round" opacity="0.7" />
          <g>
            <ellipse cx="76" cy="44" rx="9" ry="10" fill="white" stroke="#1e3a5f" strokeWidth="2.5" />
            <ellipse cx="100" cy="44" rx="9" ry="10" fill="white" stroke="#1e3a5f" strokeWidth="2.5" />
            <circle cx="78" cy="46" r="4" fill="#1e3a5f" />
            <circle cx="102" cy="46" r="4" fill="#1e3a5f" />
            <circle cx="79.5" cy="44.5" r="1.4" fill="white" />
            <circle cx="103.5" cy="44.5" r="1.4" fill="white" />
          </g>
          <path d="M82 60 Q89 66 96 60" stroke="#1e3a5f" strokeWidth="3" fill="none" strokeLinecap="round" />
          <circle cx="70" cy="57" r="2.5" fill="#fda4af" opacity="0.7" />
          <circle cx="108" cy="57" r="2.5" fill="#fda4af" opacity="0.7" />
          <path d="M20 62 Q8 58 6 48" stroke="#1e3a5f" strokeWidth="5" fill="none" strokeLinecap="round" />
          <circle cx="6" cy="46" r="5" fill="#1e3a5f" />
          <path d="M120 62 Q132 58 134 48" stroke="#1e3a5f" strokeWidth="5" fill="none" strokeLinecap="round" />
          <circle cx="134" cy="46" r="5" fill="#1e3a5f" />
          <defs>
            <linearGradient id="scheibiGlass" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#bfe3ff" />
              <stop offset="100%" stopColor="#e6f4ff" />
            </linearGradient>
          </defs>
        </svg>
        <span className="block mt-0.5 text-[11px] font-bold text-slate-500 tracking-wide">Scheibi</span>
      </button>
    </div>
  );
};
